import styled from "styled-components";
import { colors } from "../theme/colors";
import { fontSizes } from "../theme/font-sizes";
import { fontWeights } from "../theme/font-weights";
import { lineHeights } from "../theme/line-heights";
import { withBreakpoints } from "../util/responsive-styles";
const body1 = {
    fontSize: [3, 4, 5],
    lineHeight: lineHeights.body,
};
const body2 = {
    fontSize: [2, 3, 4],
    lineHeight: lineHeights.body,
};
const body3 = {
    fontSize: [1, 2, 3],
    lineHeight: lineHeights.body,
};
const variants = {
    title1: {
        fontSize: [7, 8, 9],
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.heading,
    },
    title2: {
        fontSize: [6, 7, 8],
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.heading,
    },
    title3: {
        ...body1,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.heading,
    },
    body1,
    body1Strong: {
        ...body1,
        fontWeight: fontWeights.medium,
    },
    body2,
    body2Strong: {
        ...body2,
        fontWeight: fontWeights.medium,
    },
    body3,
    body3Strong: {
        ...body3,
        fontWeight: fontWeights.medium,
    },
    body4: {
        fontSize: [0, 1, 2],
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.body,
    },
    CTA: {
        fontSize: 2,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.medium,
    },
    label: {
        fontSize: 0,
        fontWeight: fontWeights.medium,
        lineHeight: lineHeights.small,
    },
    meta: {
        fontSize: [1, 2, 3],
        lineHeight: lineHeights.body,
    },
    cardDetail: {
        fontSize: [1, 1, 2],
        lineHeight: lineHeights.medium,
    },
    category: {
        fontSize: [2, 3, 7],
        fontWeight: fontWeights.medium,
    },
    tab: {
        fontSize: [2, 3],
        fontWeight: fontWeights.regular,
    },
};
export const TextComponent = styled.div(({ variant, color, fontSize }) => {
    const { fontSize: variantFontSize, ...otherVariantProps } = variants[variant];
    const actualFontSize = fontSize ?? variantFontSize;
    return {
        ...otherVariantProps,
        ...withBreakpoints((value) => ({
            fontSize: fontSizes[value],
        }), actualFontSize),
        ...(color ? { color: colors[color] } : {}),
    };
});
